function Checkbox({checked, title, className = "black"}) {
    return (
        <div className="checkbox-wrapper">
            <input
                type="checkbox"
                checked={checked}
                onChange={() => {}}
                name={title}
            />
            <div className={className}>

            </div>
            {title && <span>{title}</span>}
        </div>
    )
}

export default Checkbox